import { triplaServer } from 'src/apis/server'

export default {
  getPayPalClientToken() {
    return triplaServer
      .post('api/triplabot/v1/paypal_payments/client_credential')
      .then((res) => res.data.data)
  },
  getPaypalOrder(data) {
    return triplaServer
      .post('api/triplabot/v1/paypal_payments/order', data)
      .then((res) => res.data.data)
  }
}
